import { useTranslation } from 'react-i18next';
import {
  type CreateDataRequestDto,
  LegalBasisPersonalDataReason,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

export const PersonalDataLegalBasisReasonNote = () => {
  // Toelichting gerechtvaardigd belang
  const { t } = useTranslation('dataRequest');
  const { FormTextArea, ConditionalField } =
    typedFormFields<CreateDataRequestDto>();

  return (
    <ConditionalField
      field="legalBasisPersonalDataReasonNote"
      condition={(formValue) => {
        return (
          formValue('legalBasisPersonalDataReason')! &&
          formValue('legalBasisPersonalDataReason') ===
            LegalBasisPersonalDataReason.LegitimateInterest
        );
      }}
    >
      <FormTextArea
        aria-label={t('legal_basis_personal_data.note.note')}
        fullWidth
        label={t('legal_basis_personal_data.note')}
        name="legalBasisPersonalDataReasonNote"
        showWordCount
        rules={{ maxLength: 200, minLength: 2, required: true }}
      />
    </ConditionalField>
  );
};
